import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LangService } from '../services/lang.service';

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  // A request that already carries Accept-Language wants a specific language
  // regardless of the UI locale (e.g. catalogs whose names we persist in ru),
  // so don't overwrite it with the current one.
  if (req.headers.has('Accept-Language')) return next(req);

  const langSvc = inject(LangService);
  const currentLang = langSvc.currentLang$();
  req = req.clone({
    setHeaders: {
      'Accept-Language': currentLang,
    },
  });
  return next(req);
};
